/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RevokeMoneybotSessionRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {RevokeMoneybotSessionResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const revokeMoneybotSession = (request: RevokeMoneybotSessionRequest, options?: CashRequestOptions) => post<RevokeMoneybotSessionRequest, RevokeMoneybotSessionResponse>("/2.0/cash/revoke-moneybot-session", request, {...options, rejectOnError: true })